export default "__VITE_ASSET__9924c867__"